import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';

import './App.scss';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import './assets/css/bootstrap.css';
import './assets/css/responsive.css';

import Layout from './component/layout/layout';

import Home from './pages/home/home';
import PageNotFound from './pages/mint/mint';
import Mint from './pages/mint/mint';
import FAQPage from './pages/faq/faq';
import Inscribe from './pages/inscribe/inscribe';

// swiper slide CSS
import 'swiper/css';
import 'swiper/css/effect-cards';
// require('dotenv').config();
// import WebContext from './context';
function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element=<PageNotFound /> />
        <Route path="/" element=<Home /> />
        <Route path="/mint" element=<Mint /> />
        <Route path="/inscribe" element=<Inscribe /> />
        <Route path="/faq" element=<FAQPage /> />

      </Routes>
      <ToastContainer />
    </BrowserRouter>
  );
}

export default App;
